import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { User } from '~/types/api/user';
import { ROLE_ENUM } from '~/types/api/user';

import * as actions from './actions';

interface IAdmin extends Partial<User> {
  auth: {
    isInProgress: boolean;
    isInitialized: boolean;
    isLoggedIn: boolean;
  };
}

const initialState: IAdmin = {
  role: ROLE_ENUM.Values.EDITOR,
  scope: [],
  auth: {
    isInProgress: false,
    isInitialized: false,
    isLoggedIn: false,
  },
};

export const admin = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setAuthProgressState: (state, action: PayloadAction<boolean>) => {
      state.auth.isInProgress = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(actions.me.pending, state => {
      state.auth.isInProgress = true;
    });
    builder.addCase(actions.me.fulfilled, (state, action) => {
      state.auth.isInProgress = false;

      if (action.payload.success) {
        state.id = action.payload.data.id;
        state.email = action.payload.data.email;
        state.role = action.payload.data.role;
        state.firstName = action.payload.data.firstName;
        state.lastName = action.payload.data.lastName;
        state.avatarUrl = action.payload.data.avatarUrl;
        state.scope = action.payload.data.scope;
        state.auth.isLoggedIn = true;
      } else {
        state.auth.isLoggedIn = false;
      }

      state.auth.isInitialized = true;
    });
    builder.addCase(actions.me.rejected, state => {
      state.auth.isInProgress = false;
      state.auth.isLoggedIn = false;
      state.auth.isInitialized = true;
    });
    builder.addCase(actions.signIn.pending, state => {
      state.auth.isInProgress = true;
    });
    builder.addCase(actions.signIn.fulfilled, (state, action) => {
      state.auth.isInProgress = false;

      if ('success' in action.payload) {
        state.id = action.payload.data.id;
        state.email = action.payload.data.email;
        state.role = action.payload.data.role;
        state.firstName = action.payload.data.firstName;
        state.lastName = action.payload.data.lastName;
        state.avatarUrl = action.payload.data.avatarUrl;
        state.scope = action.payload.data.scope;
        state.auth.isLoggedIn = true;
      } else {
        state.auth.isLoggedIn = false;
      }

      state.auth.isInitialized = true;
    });
    builder.addCase(actions.signIn.rejected, state => {
      state.auth.isInProgress = false;
      state.auth.isLoggedIn = false;
      state.auth.isInitialized = true;
    });

    builder.addCase(actions.signOut.pending, state => {
      state.auth.isInProgress = true;
    });
    builder.addCase(actions.signOut.fulfilled, state => {
      state.auth.isInProgress = false;
      state.auth.isLoggedIn = false;
    });
    builder.addCase(actions.signOut.rejected, state => {
      state.auth.isInProgress = false;
    });
  },
});

export const { setAuthProgressState } = admin.actions;
export default admin.reducer;
